/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PanResponse } from "./PanResponse";
import * as t from "io-ts";

// required attributes
const RestPanResponseR = t.interface({});

// optional attributes
const RestPanResponseO = t.partial({
  data: PanResponse
});

export const RestPanResponse = t.intersection(
  [RestPanResponseR, RestPanResponseO],
  "RestPanResponse"
);

export type RestPanResponse = t.TypeOf<typeof RestPanResponse>;
